import { FC } from 'react';
import { Box, FormLabel, Input } from '@screentone/core';

import { useDataModelContext } from 'contexts/datamodel/useDataModel';

interface PageTitleProps {
  isReadOnly?: boolean;
}

export const PageTitle: FC<PageTitleProps> = ({ isReadOnly = false }) => {
  const { metadata, setNewMetadata } = useDataModelContext();

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setNewMetadata({
      ...metadata,
      name: value
    });
  };

  return (
    <Box>
      <Box.Title>Page Title</Box.Title>
      <Box.Content>
        <FormLabel label="Page Title" labelPosition="top" fullWidth required />
        <Input type="text" name="name" value={metadata.name} onChange={handleNameChange} disabled={isReadOnly} />
      </Box.Content>
    </Box>
  );
};
